import api from '@/api/api'

export function get(uid) {
  return api.get(`/v2/zip-codes/${uid}`)
}
